import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Registration } from 'src/app/models/Registration';
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core-services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DeviceDetectorService } from "ngx-device-detector";
import { HttpClient } from "@angular/common/http";
// import { CaptchaModule } from 'primeng/ca';
import { first } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { UtmParameters } from "src/app/models/UtmParametersModel";
import { CookiesService } from "src/app/core-services/cookie.service";

@Component({
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit  {

    submitted = false;
    loading: boolean = false;
    confirmPassNotSame: boolean = false;
    countries: any = [];
    isEmail:boolean = false;
    ipaddress:string;
    captchaResponse:string;
    planId:string;
    registrationForm = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.pattern('^.{8,}$')]],
        confirmPassword: ['', [Validators.required, Validators.pattern('^.{8,}$')]],
        companyName: [''],        
        termsAndConditions: ['', Validators.required]
    });

    constructor(private fb: FormBuilder,
         private toastr: ToastrService,
         private authenticationService: AuthService,
         private router: Router,
         private spinner: NgxSpinnerService,
         private deviceService: DeviceDetectorService,
         private http: HttpClient,
         private route: ActivatedRoute,
         private cookieService: CookiesService) {
             
    }

    ngOnInit() {
        this.planId=  this.route.snapshot.paramMap.get("planId");
    }
    get f() { return this.registrationForm.controls; }

    public hasError = (controlName: string, errorName: string) => {
        return this.registrationForm.controls[controlName].hasError(errorName);
    }

    checkPasswords() {
        let pass = this.registrationForm.controls.password.value;
        let confirmPass = this.registrationForm.controls.confirmPassword.value;

        if (pass) {
            if (pass === confirmPass) {
                this.confirmPassNotSame = false;
            }
            else {
                this.confirmPassNotSame = true;
            }
        }
        else {
            this.confirmPassNotSame = false;
        }
    }

    // getCountries() {
    //     this.spinner.show();
    //     this.authenticationService.getCountry().subscribe((response: any) => {
    //         if (response != null && response.content != null) {
    //             this.countries = response.content;
    //         }
    //         this.spinner.hide();
    //     })
    //     // this.spinner.hide();
    // }

    onSubmit() {
        localStorage.removeItem('currentUser');
        this.submitted = true;
        var termsConditions: any = this.registrationForm.controls.termsAndConditions.value;
        if (this.registrationForm.invalid) {
            if (this.registrationForm.controls.password.value != null && this.registrationForm.controls.password.value != '') {
                this.toastr.warning('Passwords must contain at least eight characters.', 'Oops !');
            }
            return;
        }
        else if(this.isEmail != true)
        {
            this.toastr.warning('"Email already exists, Please use another email.');
            return;
        }
        else if (termsConditions == false) {
            this.toastr.error('Terms and conditions is required !', 'Error');
            return;
        }
        else if(this.captchaResponse ==""){
            this.toastr.error('Please resolve captcha !', 'Error');
            return;
        }
        else {
            let model: any = new Registration();
            model = this.registrationForm.value;
            if (model != null && model.password == model.confirmPassword) {
                this.spinner.show();

                var deviceInfo = this.deviceService.getDeviceInfo();
                     model.isMobile = this.deviceService.isMobile();
                     model.IsTab = this.deviceService.isTablet();
                     model.isDesktop = this.deviceService.isDesktop();
                     
                     if(this.cookieService.getCookie('utmparam')){
                        const utmParams= JSON.parse(this.cookieService.getCookie('utmparam')) as UtmParameters
                         model.UtmTerm = utmParams.utmTerm;
                         model.UtmSource = utmParams.utmSource;
                         model.UtmContent = utmParams.utmContent;
                         model.UtmCampaign = utmParams.utmCampaign;
                         model.UtmMedium = utmParams.utmMedium;
                     }

                  this.http.get<{ip:string}>('https://jsonip.com')
                     .subscribe(data=>{this.ipaddress = data.ip });
                     model.mobileIp = model.isMobile == true ? this.ipaddress :null;
                     model.TabIp = model.IsTab == true ? this.ipaddress :null;
                     model.desktopIp = model.isDesktop == true ? this.ipaddress :null;
                     model.captchaResponse = this.captchaResponse;
                    model.planId = this.planId && this.planId == "1"? this.planId : null;  
                     this.authenticationService.registerUser(model).pipe(first()).subscribe((response: any) => {

                      if (response && response.isSuccess) {
                          this.cookieService.deleteCookie('utmparam');
                        this.spinner.hide();

                        if (response.usersDetailsVM.planId != null && response.usersDetailsVM.planId == 1) {
                            this.router.navigate(['/signup-confirmation']);
                        } else {
                          this.router.navigate(['/signup-confirmation']);
                        }
                    }
                    else {
                      this.spinner.hide();
                    }
                })
            }
            else {
                this.toastr.error('Password and Confirm Password should be same !', 'Error');
            }
        }
    }
    checkEmailExist() {
        var email = this.registrationForm.controls.email.value;

        if (email) {
            if (this.registrationForm.controls.email.status != 'INVALID') {
                var data = {
                    userName : email
                };

                this.authenticationService.checkEmailExist(data).subscribe((response: any) => {
                    if (response != null && response.content != null) {
                        if (response.isSuccess == false && response.content == false) {
                            this.isEmail = true;
                        }
                        else {
                            this.toastr.warning(response.message);
                            this.isEmail = false;
                        }
                    }
                })
            }
        }
    }
    onKeyPress(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };

    showResponse = function(response) {
        this.captchaResponse=response.response;
    };

    resetCaptcha = function(event){
        this.captchaResponse="";
    };


}
